export const borrowMarketsTableColumns = [
  'token',
  'protocol',
  'name',
  'collateral',
  'marketSize',
  'availableToBorrow',
  'borrowRate',
] as const

export const borrowMarketsSortableColumns = [
  'token',
  'protocol',
  'name',
  'marketSize',
  'availableToBorrow',
  'borrowRate',
] as const

export type BorrowMarketsTableColumn = (typeof borrowMarketsTableColumns)[number]
export type BorrowMarketsSortableColumn = (typeof borrowMarketsSortableColumns)[number]

export function isBorrowMarketsSortableColumn(value: string): value is BorrowMarketsSortableColumn {
  return borrowMarketsSortableColumns.includes(value as BorrowMarketsSortableColumn)
}
